/*
 * DashboardHome Messages
 *
 * This contains all the text for the DashboardHome scene.
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.DashboardHome";

export default defineMessages(scope, {
  greeting: "Welcome back,",
  greetingWithoutComma: "Welcome back",
  securitySettingsLabel: "Security Settings",
  logoutLabel: "Sign out",
  switchFirmLabel: "Switch Firm",
  appTitleLabel: "Choose an application",
  appName: "NextGen Trading",
  noAppsMessage: "No apps available, please contact your administrator.",
});
